import { render } from "./UserExitChats.vue?vue&type=template&id=376a99cb&scoped=true"
import script from "./UserExitChats.vue?vue&type=script&lang=js"
export * from "./UserExitChats.vue?vue&type=script&lang=js"

import "./UserExitChats.vue?vue&type=style&index=0&id=376a99cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376a99cb"]])

export default __exports__